import { Component, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
// import { Map, MapView, Extent, SpatialReference, Point } from 'esri-mods';

import { EventsService } from '../../shared/Events.service';
import {ElectionService} from '../../shared/election-service/election.service';
// import { LoadingComponent } from '../../loading/loading.component';
import { SettingsService } from '../../shared/settings/settings.service';
// import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';


@Component({
    selector: 'district-info',
    // templateUrl: 'app/information/votingdistrict/votingdistrict.component.html'
    template: require('./votingdistrict.component.html')
    // directives: [LoadingComponent]

})
export class VotingDistrictComponent implements OnInit {

    votingDistrictInfo: Object;
    tabActivated:boolean = false;
    appSettings: Object;
    isDistrictRetrieved:boolean = false;
    error: any;

    private selectedAddressLocation:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService, private _electionService: ElectionService,  private _settingsService: SettingsService) { 
        

        
    }


    ngOnInit() {
                this._eventsService.selectedAddressObject$.subscribe(address => {
                    //get the current address
                     this.selectedAddressLocation = address["addressLocation"];
                     //this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion.FullAddress : this.selectedFullAddress = "Address undefined";
                    //  this.selectedAddressLocation ? this.getDistrictInformation() : console.log("Address location is undefined");

                 }
                ); 

                this._eventsService.searchInvoked$.subscribe(
                    address => {
                        //get the current address
                        this.selectedAddressLocation = address["addressLocation"];
                        this.isDistrictRetrieved = false;
                        this.selectedAddressLocation ? this.getDistrictInformation() : console.log("Address location is undefined");

                    }

                );

            // Get app settings from settings service      
            this._settingsService.getAppSettings().subscribe(
                settings => { 
                    this.appSettings = settings[0];

                    let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Districts'; });
                    this.tabActivated = currentTabSettings[0].activate;
                
                // this.electionServiceURL = this.appSettings["electionServiceURL"];
                },
                err => { this.error = true }
            ); 
    }

    getDistrictInformation() {
         this._electionService
            .getDistricts(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(district => {
                this.isDistrictRetrieved = true;
                 this.votingDistrictInfo = district
                // this.pollingPlaceName = pollingplace.Name
                // this.photos = pollingplace.Photos
                // this.pollingPlacePrecinct = pollingplace.Precinct;
                // this.pollingPlaceAddress = pollingplace.StreetAddress;
                // this.pollingPlaceCity = pollingplace.City
                }
            )
            .catch(error => this.error = error);
    }


    // ngAfterContentInit () {

        
    // }
    // destroy map
    ngOnDestroy() {

    }

}


// WEBPACK FOOTER //
// ./app/information/votingdistrict/votingdistrict.component.ts